import { f7 } from 'framework7-react';
import { useCallback, useMemo } from 'react';
import {
  CheckInReserveDataType,
  InsuranceEntryItemType,
} from '../../../types/bodyAndPaint';
import { useInsuranceState } from './hook/state/useInsuranceState';
import { useStorageItem } from './hook/useStorageItem';
import { CheckInUseInsurance } from './insuranceEntry/checkInUseInsurance';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const CheckInUseInsurancePage = () => {
  const { stored: checkInEntries, setStorageItem: setCheckInEntries } =
    useStorageItem<CheckInReserveDataType>({ key: 'checkInReserve' });

  const initialInsuranceInfo = useMemo(
    () => checkInEntries?.insuranceInfo ?? ({} as InsuranceEntryItemType),
    [checkInEntries?.insuranceInfo],
  );
  const {
    insuranceState,
    insuranceSetState,
    insuranceSelectList,
    insuranceError,
    pickerInfo,
    disabled,
    hasDeductible,
    isInsurance,
  } = useInsuranceState({
    initial: initialInsuranceInfo,
  });

  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsCheckInCarCondition);
  };
  const handleClickNext = useCallback(() => {
    setCheckInEntries((prev) => ({
      ...prev,
      insuranceInfo: insuranceState,
    }));
    f7.views.main.router.navigate(paths.bpsCheckInReserveDate);
  }, [insuranceState, setCheckInEntries]);
  return (
    <PageTemplateComponent
      pageName={'checkInReserve'}
      title={'傷・凹み修理予約'}
      onBack={handleClickBack}
    >
      <CheckInUseInsurance
        isInsurance={isInsurance}
        disabled={disabled}
        onNext={handleClickNext}
        state={insuranceState}
        setState={insuranceSetState}
        selectList={insuranceSelectList}
        error={insuranceError}
        pickerInfo={pickerInfo}
        hasDeductible={hasDeductible}
      />
    </PageTemplateComponent>
  );
};
